import React from "react";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { yyyymmddGenerator } from "../Analytics/AnalyticsUtils/yyyymmddGenerator";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useAppStore } from "../../../appStore";
import { enUS, enGB } from "date-fns/locale";

export const StartDateDropDownSentinel = ({
  userFiltersSentinel,
  setUserFiltersSentinel,
  setTimeFiltersDisabledSentinel,
}: {
  userFiltersSentinel: any;
  setUserFiltersSentinel: Dispatcher<any>;
  setTimeFiltersDisabledSentinel: Dispatcher<boolean>;
}) => {
  const [startTimeAnchorEl, setStartTimeAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const startTimeOpen = Boolean(startTimeAnchorEl);
  const handleStartTimeClick = (event: React.MouseEvent<HTMLElement>) => {
    setStartTimeAnchorEl(event.currentTarget);
  };
  const handleStartTimeClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setStartTimeAnchorEl(null);
  };

  const { dateMMDDYYYY, setDateMMDDYYYY } = useAppStore();

  const selectedLocale = dateMMDDYYYY ? enUS : enGB;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={selectedLocale}
    >
      <DatePicker
        label={
          userFiltersSentinel.start_date ? (
            <div className="flex">
              <>Start Date</>
              <div>
                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-controls={startTimeOpen ? "long-menu" : undefined}
                  aria-expanded={startTimeOpen ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleStartTimeClick}
                  sx={{
                    marginLeft: "5px",
                    padding: 0,
                    color: "#000000",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  MenuListProps={{
                    "aria-labelledby": "long-button",
                  }}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  anchorEl={startTimeAnchorEl}
                  open={startTimeOpen}
                  onClose={handleStartTimeClose}
                  slotProps={{
                    paper: {
                      style: {
                        maxHeight: 48 * 4.5,
                        width: "20ch",
                      },
                    },
                  }}
                >
                  <MenuItem
                    key="mm-dd-yyyy-start"
                    onClick={(event) => {
                      setDateMMDDYYYY(true);
                      handleStartTimeClose(event);
                    }}
                  >
                    MM/DD/YYYY
                  </MenuItem>
                  <MenuItem
                    key="dd-mm-yyyy-start"
                    onClick={(event) => {
                      setDateMMDDYYYY(false);
                      handleStartTimeClose(event);
                    }}
                  >
                    DD/MM/YYYY
                  </MenuItem>
                </Menu>
              </div>
            </div>
          ) : (
            <>Start Date</>
          )
        }
        value={userFiltersSentinel.start_date}
        onChange={(newValue) => {
          if (newValue !== null) {
            setUserFiltersSentinel((previousState: any) => {
              return { ...previousState, start_date: newValue };
            });
          }
          if (newValue === null) {
            setUserFiltersSentinel((previousState: any) => {
              return { ...previousState, start_date: null };
            });
          }
          if (
            yyyymmddGenerator(newValue) !==
            yyyymmddGenerator(userFiltersSentinel.end_date)
          ) {
            setTimeFiltersDisabledSentinel(true);
            setUserFiltersSentinel((previousState: any) => {
              return { ...previousState, start_time: null, end_time: null };
            });
          }
          if (
            yyyymmddGenerator(newValue) ===
            yyyymmddGenerator(userFiltersSentinel.end_date)
          ) {
            setTimeFiltersDisabledSentinel(false);
          }
        }}
        renderInput={(params) => <TextField sx={{ width: 150 }} {...params} />}
      />
    </LocalizationProvider>
  );
};
